import {
  TOUR_LEAD_MANAGEMENT_DATA,
  TOUR_LEAD_MANAGEMENT_DATA_SUCCESS,
  TOUR_LEAD_MANAGEMENT_DATA_FAIL,
  TOUR_LEAD_MANAGEMENT_DETAILS,
  TOUR_LEAD_MANAGEMENT_DETAILS_SUCCESS,
  TOUR_LEAD_MANAGEMENT_DETAILS_FAIL,
  TOUR_LEAD_MANAGEMENT_UPDATE_SUCCESS,
  TOUR_LEAD_MANAGEMENT_UPDATE_FAIL,
  TOUR_LEAD_MANAGEMENT_UPDATE,
  TOUR_LEAD_MANAGEMENT_LIST_ALL_SUCCESS,
  TOUR_LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS,
  TOUR_LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS,
  TOUR_LEAD_MANAGEMENT_LIST_PENDING_SUCCESS,
  TOUR_LEAD_MANAGEMENT_REVIEW_FAIL,
  TOUR_LEAD_MANAGEMENT_REVIEW_SUCCESS,
  TOUR_LEAD_MANAGEMENT_REVIEW,
  TOUR_LEAD_MANAGEMENT_CSV_START,
  TOUR_LEAD_MANAGEMENT_CSV_SUCCESS,
  TOUR_LEAD_MANAGEMENT_CSV_ERROR,
} from "../Constants/TourLeadManagementConstants";

const initialState = {
  toursLeadsLoading: false,
  toursLeadData: [],
  toursLeadsViewLoading: false,
  toursLeadsViewSuccess: [],
  toursLeadsDetails: null,
  toursLeadsUpdateLoading: false,
  toursLeadUpdate: [],
  toursallListData: [],
  tourspendingListData: [],
  tourscompletedListData: [],
  toursdroppedListData: [],
  toursreviewSuccess: [],
  toursreviewLoading: false,
  tourCsvLoading: false,
};

export default function tourLeadManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case TOUR_LEAD_MANAGEMENT_DATA:
      return {
        ...state,
        toursLeadsLoading: true,
      };
    case TOUR_LEAD_MANAGEMENT_DATA_SUCCESS:
      return {
        ...state,
        toursLeadsLoading: false,
        toursLeadData: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_DATA_FAIL:
      return {
        ...state,
        toursLeadsLoading: false,
        toursLeadData: [],
      };
    case TOUR_LEAD_MANAGEMENT_DETAILS:
      return {
        ...state,
        toursLeadsLoading: true,
        toursLeadsDetails: null,
      };
    case TOUR_LEAD_MANAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        toursLeadsLoading: false,
        toursLeadsDetails: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_DETAILS_FAIL:
      return {
        ...state,
        toursLeadsLoading: false,
        toursLeadsDetails: null,
      };
    case TOUR_LEAD_MANAGEMENT_UPDATE:
      return {
        ...state,
        toursLeadsUpdateLoading: true,
      };
    case TOUR_LEAD_MANAGEMENT_UPDATE_SUCCESS:
      return {
        ...state,
        toursLeadsUpdateLoading: false,
        toursLeadUpdate: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_UPDATE_FAIL:
      return {
        ...state,
        toursLeadsUpdateLoading: false,
        toursLeadUpdate: [],
      };
    case TOUR_LEAD_MANAGEMENT_LIST_ALL_SUCCESS:
      return {
        ...state,
        toursallListData: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_LIST_PENDING_SUCCESS:
      return {
        ...state,
        tourspendingListData: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS:
      return {
        ...state,
        tourscompletedListData: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS:
      return {
        ...state,
        toursdroppedListData: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_REVIEW:
      return {
        ...state,
        toursreviewLoading: true,
      };
    case TOUR_LEAD_MANAGEMENT_REVIEW_SUCCESS:
      return {
        ...state,
        toursreviewLoading: false,
        toursreviewSuccess: action.payload,
      };
    case TOUR_LEAD_MANAGEMENT_REVIEW_FAIL:
      return {
        ...state,
        toursreviewLoading: false,
      };
    case TOUR_LEAD_MANAGEMENT_CSV_START:
      return {
        ...state,
        tourCsvLoading: true,
      };
    case TOUR_LEAD_MANAGEMENT_CSV_SUCCESS:
      return {
        ...state,
        tourCsvLoading: false,
      };
    case TOUR_LEAD_MANAGEMENT_CSV_ERROR:
      return {
        ...state,
        tourCsvLoading: false,
      };
    default:
      return state;
  }
}
